const moduleName = "afiliasiModule";

const menuDetail = [
  {
    id: 1,
    title: "Mutasi Saldo",
    subTitle: "Lihat aktivitas saldo",
    linkTo: "afiliasi.mutasi_saldo",
  },
  {
    id: 2,
    title: "Rekening Tarik Tunai",
    subTitle: "Rekening pencairan belum diisi",
    linkTo: "afiliasi.set_rekening",
  },
  {
    id: 3,
    title: "Riwayat Tarik Tunai",
    subTitle: "Total pencairan selama ini",
    linkTo: "afiliasi.cash_history",
  },
  {
    id: 4,
    title: "Teman Yang Bergabung",
    subTitle: "Belum ada teman yang bergabung",
    linkTo: "afiliasi.afiliated",
  },
  {
    id: 5,
    title: "Syarat dan Ketentuan",
    subTitle: "",
    linkTo: "afiliasi.terms_conditions",
  },
];

const pagination = () => ({
  limit: 11,
  offset: 0,
  length: 0,
  pageNumber: 0,
});

const state = () => ({
  //Api
  fetching: false,
  loadMore: false,
  response: {},

  //Static
  afiliasiSet: {
    saldo: 0,
    referalLink: "",
    rekening: {
      namaBank: "",
      noRekening: "",
      pemilik: "",
    },
    afiliated: {
      totalTeman: "",
      totalOutlet: "",
    },
  },

  // Data
  cashWithdraw: 0,
  lastWithdraw: [],
  totalWithdraw: 0,
  mutasiSaldo: [],
  withdrawHistory: [],
  withdrawHistoryTotal: 0,
  afiliated: [],
  afiliatedTotal: 0,
  listBank: [],
  detailOwner: {},

  //Filter
  pagination: pagination(),
});

export { state as default, moduleName, menuDetail, pagination };
